import Marionette from 'backbone.marionette';

import template from '../templates/entranceModal.ejs';
import alertTemplate from '../templates/alert.ejs';
import MemberModel from "./MemberModel";

export default Marionette.View.extend( {
   template: template,

   ui: {
      email: '#email-address',
      emailSubmit: '#email-submit'
   },

   events: {
      'submit': 'emailSubmitted',
      'change @ui.email': 'updateEmail',
   },

   regions: {
      alert: '#entrance-alert'
   },

   initialize: function ( options ) {
      this.mergeOptions( options, ['model', 'app'] );

      this.validator = new MemberModel();
      this.listenTo( this.validator, 'invalid', () => {
         this.getUI( 'email' ).addClass( 'is-invalid' ).next().show();
      } );
      this.listenTo( this.validator, 'change:email_address', () => {
         this.getUI( 'email' ).removeClass( 'is-invalid' ).addClass( 'is-valid' ).next().hide();
      } );
   },

   // Custom API called in ModalRegion
   onModalShown: function () {
      this.getUI( 'email' ).focus();
   },

   updateEmail: function ( event ) {
      this.validator.set( 'email_address', event.target.value, {validate: true} );
   },

   emailSubmitted: function () {
      if( this.getUI( 'emailSubmit' ).hasClass( 'disabled' ) ) {
         return false
      }
      if( this.validator.isValid() ) {
         this.getUI( 'emailSubmit' ).addClass( 'loading disabled' );

         this.model.set( 'email_address', this.getUI( 'email' ).val().trim().toLowerCase() );
         this.model.fetch( {
            success: this.emailFound.bind( this ),
            error: this.emailNotFound.bind( this )
         } );
      }
      else {
         this.getUI( 'email' ).focus();
      }
      return false
   },

   emailFound: function ( model ) {
      if( model.get( 'status' ) !== 'subscribed' ) {
         this.app.showAlert( 'alert-success', this.app.data.alerts.newSubscriber );
      }
      else {
         this.app.showAlert( 'alert-success', this.app.data.alerts.existingSubscriber );
      }
      this.app.getRegion( 'modal' ).empty(); // Close the modal and destroy this view.
   },

   emailNotFound: function ( model, response ) {
      this.getUI( 'emailSubmit' ).removeClass( 'loading disabled' );

      if( response.status === 0 ) {
         this._showError( this.app.data.alerts.networkError );
      }
      else if( response.status === 404 ) {
         this.app.showAlert( 'alert-success', this.app.data.alerts.newSubscriber );
         this.app.getRegion( 'modal' ).empty(); // Close the modal and destroy this view.
      }
      else {
         this._showError( this.app.data.alerts.applicationError );
      }
   },

   _showError: function ( message ) {
      this.getRegion( 'alert' ).show( {
         template: alertTemplate,
         templateContext: {
            alertClass: 'alert-danger',
            message: message,
         }
      } );
   }
} );
